import React, { useEffect, useState } from "react";
import { Modal, Space, Button } from "antd";
import axios from "axios";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import PageContent from "../../components/layout/PageContent";
import { getTableState } from "../../utils/localStorage";
import { getFormattedResponse } from "../../utils";
import CustomTable from "../../components/table/CustomTable";

const tablePrefix = 'config_users';

const Users = () => {

	const [ data, setData ] = useState([]);
	const [ columns, setColumns ] = useState([]);
	const [ tableState, setTableState ] = useState(() => {
        const {
            pageSize = 10,
            page = 1,
            loading = false,
            totalSize = 1
        } = getTableState(tablePrefix);
        return {
            pageSize,
            page,
            loading,
            totalSize,
        }
    });

	const confirm = Modal.confirm;

  	useEffect(() => {
		const { page, size } = tableState;
        fetchData({
            page,
            size
        });
        // Зөвхөн mount дээр эхний хуудсыг татна.
        // eslint-disable-next-line react-hooks/exhaustive-deps
  	}, []);

	const fetchData = (params) => {
		setData([]);
		setTableState((prevState) => ({ ...prevState, loading: true }));
		axios
			.post(
				"/api/1.0/user/list",
				params,
			)
			.then(({ data }) => {
				const { 
					list, 
					columns: cols,
					rest: { totalDocs = 1, limit = 20 } = {},  
				} = getFormattedResponse(data);
				setColumns(cols);
				setData(list);
				setTableState((prevState) => {
					return {
						...prevState,
						totalSize: totalDocs,
						loading: false,
						pageSize: limit,
					}
				});
			})
			.catch((e) => {
				console.error('Fetch Users: ', e);
			})
			.finally(() => {
				setTableState((prevState) => ({ ...prevState, loading: false }));
			});
  	};

  	const handleInteraction = ({ page, pageSize, query, sort, order }) => {
		const params = {
			page, 
			size: pageSize,
			query,
			sort,
			order
		};
		setTableState({
			...tableState,
			page,
			pageSize,
			loading: true,
			sort,
			order
		})
		fetchData(params);
	};

	const deleteUser = (id) => {
		return new Promise((resolve, reject) => {
			axios.delete(`/api/1.0/user/${id}`)
			.then(({ data }) => {
				if (data.statusCode === 200) {
					fetchData(tableState);
				}
				resolve();
			})
			.catch(e => {
				reject();
				console.error('Delete User: ', e);
			})
		})
	}

	const showConfirm = (_id) => {
		confirm({
			title: "Мэдээллийг устгах уу?",
			okText: "Устгах",
			cancelText: "Цуцлах",
			okType: 'danger',
			onOk() {
				// Promise буцаавал устгаж дуустал "Устгах" товч loading байна
				return deleteUser(_id);
			},
		});
	};

	const getColumns = () => {

		const additionalColumns = [
			{
				key: "action",
				width: 1,
				sorter: false,
				fixed: 'right',
				render: (text, record) => (
					<Space size="middle" align="center">
						<Link 
							to={{
								pathname: '/user/edit',
								state: {
									id: record._id
								},
							}}
						>
							<EditOutlined />
						</Link>
						<DeleteOutlined onClick={() => showConfirm(record._id)} />
					</Space>
				),
			},
		];

		return [
			...columns,
			...additionalColumns
		];
	};

	const getSubheaderContent = () => {
		return (
			<Link to={`/user/add`}>
				<Button type='primary'>
					Шинэ хэрэглэгч үүсгэх
				</Button>
			</Link>
		)
	}

	return (
		<PageContent
			subheader={{
				title: 'Системийн хэрэглэгч',
				background: '#ffffff',
				content: getSubheaderContent(),
			}}
		>
			<CustomTable
				bordered
				prefix={tablePrefix}
				dataSource={data}
				columns={getColumns()}
				rowKey='_id'
				showAll={false}
				onInteract={handleInteraction}
				state={tableState}
			/>
	  	</PageContent>
	)
};

export default Users;
